import { useTranslation } from "react-i18next";
import securityBank from "@/assets/home/security-bank.webp";
import securityKey from "@/assets/home/security-key.webp";
import securityLock from "@/assets/home/security-lock.webp";
import securityShield from "@/assets/home/security-shield.webp";
import securityVault from "@/assets/home/security-vault.webp";
import { BackdropVideo } from "@/components/marketing/BackdropVideo";
import { Section, SectionHeader } from "@/components/marketing/Section";
import { StaggeredList } from "@/components/ui/motion";

// Glass renders follow the item order in `security.items`: vault (strategy
// privacy), padlock (encryption), key (scoped access), shield (approval gate
// + audit), bank facade (funds stay at broker).
const ITEM_IMAGES = [securityVault, securityLock, securityKey, securityShield, securityBank];

export function SecurityPrivacy() {
  const { t } = useTranslation();
  const items = t("security.items", { returnObjects: true }) as {
    label: string;
    body: string;
  }[];

  return (
    <Section id="security" viewport>
      {/* Dark fluted privacy glass (seamless-loop re-encode of the Mux
          source) — quiet motion for the trust section. */}
      <BackdropVideo src="/videos/fluted-glass-loop.mp4" />
      <div className="relative z-[1]">
        <SectionHeader title={t("security.title")} subtitle={t("security.subtitle")} />
        {/* Same card anatomy as "What we provide": glass render on top, copy below. */}
        <StaggeredList
          className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5"
          staggerDelay={0.08}
        >
          {items.map((item, index) => (
            <div
              key={item.label}
              className="glass-card flex h-full flex-col overflow-hidden rounded-[2rem]"
            >
              <div className="p-3 pb-0">
                <div className="relative aspect-[16/9] w-full overflow-hidden rounded-[1.25rem] bg-muted">
                  <img
                    src={ITEM_IMAGES[index] ?? securityShield}
                    alt=""
                    loading="lazy"
                    className="h-full w-full object-cover"
                  />
                </div>
              </div>
              <div className="flex flex-1 flex-col gap-2 p-5">
                <h3 className="text-base font-semibold text-foreground">{item.label}</h3>
                <p className="text-sm leading-relaxed text-muted-foreground">{item.body}</p>
              </div>
            </div>
          ))}
        </StaggeredList>
      </div>
    </Section>
  );
}
